import { Instagram, Mail, ArrowUp } from "lucide-react";
import { LOGO_URL, WHATSAPP_NUMBER, scrollToId } from "@/lib/site";
import { Reveal } from "./motion-prims";

export default function Footer() {
  const toTop = () => {
    if (window.__lenis) window.__lenis.scrollTo(0);
    else window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer data-testid="footer" className="relative bg-olive text-cream pt-16 sm:pt-20 pb-8 overflow-hidden">
      <div className="sunburst-dark absolute -bottom-48 -left-48 w-[520px] aspect-square rounded-full pointer-events-none" aria-hidden="true" />
      <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-8 pb-12 border-b-2 border-cream/15">
            <div className="flex items-center gap-5">
              <img
                src={LOGO_URL}
                alt="Badge Public Relations 2025"
                className="w-20 h-20 sm:w-24 sm:h-24 rounded-full border-2 border-gold-soft object-cover"
              />
              <div>
                <p className="font-display font-black text-2xl sm:text-4xl leading-tight tracking-tight">
                  BANTU DONASI
                  <span className="block text-gold-soft italic">Bersama PR</span>
                </p>
                <p className="mt-2 text-xs sm:text-sm text-cream/60 tracking-[0.2em] uppercase font-bold">
                  Public Relations 2025
                </p>
              </div>
            </div>
            <nav className="flex flex-wrap gap-x-7 gap-y-3">
              {[
                ["program", "Program"],
                ["cara-donasi", "Cara Donasi"],
                ["donasi", "Salurkan Donasi"],
                ["transparansi", "Transparansi"],
                ["sponsor", "Sponsor"],
                ["faq", "FAQ"],
              ].map(([id, label]) => (
                <button
                  key={id}
                  data-testid={`footer-link-${id}`}
                  onClick={() => scrollToId(id)}
                  className="text-sm font-semibold text-cream/75 hover:text-gold-soft transition-colors"
                >
                  {label}
                </button>
              ))}
            </nav>
          </div>
        </Reveal>

        <div className="py-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
          <p className="text-sm text-cream/60 max-w-md leading-relaxed">
            Gerakan donasi sosial oleh Divisi Public Relations 2025. Aksi nyata untuk sesama — dari
            pendidikan, pangan, hingga lingkungan hidup.
          </p>
          <div className="flex items-center gap-3">
            <a
              href={`https://wa.me/${WHATSAPP_NUMBER}`}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-social-wa"
              aria-label="WhatsApp"
              className="grid place-items-center w-11 h-11 rounded-full border-2 border-cream/30 hover:border-gold-soft hover:text-gold-soft transition-colors"
            >
              <Mail className="w-5 h-5" />
            </a>
            <a
              href="#"
              onClick={(e) => e.preventDefault()}
              data-testid="footer-social-instagram"
              aria-label="Instagram"
              className="grid place-items-center w-11 h-11 rounded-full border-2 border-cream/30 hover:border-gold-soft hover:text-gold-soft transition-colors"
            >
              <Instagram className="w-5 h-5" />
            </a>
            <button
              data-testid="footer-top-button"
              onClick={toTop}
              className="grid place-items-center w-11 h-11 rounded-full bg-gold text-ink border-2 border-ink shadow-retro-sm hover:-translate-y-1 transition-transform"
              aria-label="Kembali ke atas"
            >
              <ArrowUp className="w-5 h-5" />
            </button>
          </div>
        </div>

        <p className="text-center text-xs text-cream/45 pt-6 border-t-2 border-cream/15">
          © 2025 BANTU DONASI BERSAMA PR — Public Relations 2025. Semua hak dilindungi.
        </p>
      </div>
    </footer>
  );
}
